<template>
  <div>
    <v-col class="col-12">
      <v-sheet class="iol-switch-v-sheet col-12">
        <v-row>
          <v-col v-if="field.is_rk" class="col-5"
            >Radial keratotomy: {{ field.is_rk ? 'Yes' : 'No' }}
          </v-col>
          <v-col v-if="field.is_non_physio_cornea" class="col-5"
            >Non-physiological cornea:
            {{ field.is_non_physio_cornea ? 'Yes' : 'No' }}
          </v-col>
          <v-col v-if="field.is_icl" class="col-2"
            >ICL: {{ field.is_icl ? 'Yes' : 'No' }}
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </div>
</template>

<style scoped>
.iol-switch-v-sheet {
  padding: 10px;
  background-color: inherit !important;
}
</style>

<script>
export default {
  name: 'iol-result-switch_hist',
  props: ['fields'],
  components: {},
  data() {
    return {
      field: this.fields,
    }
  },
  created() {
    this.$emit('fields', this.field)
  },
}
</script>
